(function () {
  function initGallery(gallery) {
    if (gallery.dataset.etGalleryReady) return;
    gallery.dataset.etGalleryReady = 'true';

    var slides = gallery.querySelectorAll('[data-et-slide]');
    var thumbs = gallery.querySelectorAll('[data-et-thumb]');
    var featuredImgs = gallery.querySelectorAll('[data-et-featured-img]');
    var main = gallery.querySelector('.et-gallery__main');
    var thumbsEl = gallery.querySelector('.et-gallery__thumbs');

    /* Ordered list of slide indices as they appear in the DOM. */
    var order = Array.prototype.map.call(slides, function (s) {
      return s.getAttribute('data-et-slide');
    });

    function currentIndex() {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-active')) {
          return order.indexOf(slides[i].getAttribute('data-et-slide'));
        }
      }
      return 0;
    }

    function scrollThumbIntoView(index) {
      if (!thumbsEl) return;
      var thumb = gallery.querySelector('[data-et-thumb="' + index + '"]');
      if (!thumb) return;
      var left = thumb.offsetLeft - (thumbsEl.clientWidth - thumb.clientWidth) / 2;
      thumbsEl.scrollTo({ left: left, behavior: 'smooth' });
    }

    function activate(index) {
      slides.forEach(function (slide) {
        slide.classList.toggle('is-active', slide.getAttribute('data-et-slide') === index);
      });
      thumbs.forEach(function (thumb) {
        var active = thumb.getAttribute('data-et-thumb') === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
      scrollThumbIntoView(index);
    }

    function go(delta) {
      if (!order.length) return;
      var next = currentIndex() + delta;
      if (next < 0) next = 0;
      if (next > order.length - 1) next = order.length - 1;
      activate(order[next]);
    }

    function showFeatured(featured) {
      if (!featuredImgs.length) return;
      var matched = false;
      featuredImgs.forEach(function (img) {
        var active = img.getAttribute('data-et-featured-img') === String(featured);
        img.classList.toggle('is-active', active);
        if (active) matched = true;
      });
      /* If the requested plan has no featured image, keep the first one visible. */
      if (!matched) {
        featuredImgs.forEach(function (img, i) {
          img.classList.toggle('is-active', i === 0);
        });
      }
      /* Bring the featured slide (index 0) to the front. */
      activate('0');
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (event) {
        /* Ignore the click that ends a drag-scroll of the strip. */
        if (thumbsEl && thumbsEl.dataset.etDragged === 'true') {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        activate(thumb.getAttribute('data-et-thumb'));
      });
    });

    /* Swipe / drag the main image (mouse, touch, pen). */
    if (main) {
      var sx = 0, sy = 0, tracking = false;
      main.addEventListener('pointerdown', function (e) {
        tracking = true;
        sx = e.clientX;
        sy = e.clientY;
      });
      main.addEventListener('pointerup', function (e) {
        if (!tracking) return;
        tracking = false;
        var dx = e.clientX - sx;
        var dy = e.clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          go(dx < 0 ? 1 : -1);
        }
      });
      main.addEventListener('pointercancel', function () {
        tracking = false;
      });
    }

    /* Mouse drag-to-scroll for the thumbnail strip (touch uses native scroll).
       No pointer capture, so a plain click still reaches the thumbnail button. */
    if (thumbsEl) {
      var down = false, startX = 0, startScroll = 0, moved = false;
      thumbsEl.dataset.etDragged = 'false';

      thumbsEl.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true;
        moved = false;
        startX = e.clientX;
        startScroll = thumbsEl.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        thumbsEl.scrollLeft = startScroll - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        if (moved) {
          /* Suppress the click that ends a real drag; clear right after. */
          thumbsEl.dataset.etDragged = 'true';
          setTimeout(function () { thumbsEl.dataset.etDragged = 'false'; }, 0);
        }
      });
    }

    document.addEventListener('et:subs:plan-change', function (event) {
      if (event.detail && event.detail.featured) {
        showFeatured(event.detail.featured);
      }
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-et-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
